module.exports = __webpack_public_path__ + "img/24.431ad860.jpg";